<template>
	<form v-on:submit.prevent="saveUser">
		<fieldset>
			<legend><i v-bind:class="'fad ' + icon"></i> {{title}}</legend>
			<div class="label-field">
				<div class="field-group">
					<div>
						<label for="nameFirst">
							<i class="fad fa-user"></i> First Name
						</label>
						<input id="nameFirst" v-model="nameFirst" type="text" minlength="2" required />
					</div>
					<div>
						<label for="nameLast">
							<i class="fad fa-user"></i> Last Name
						</label>
						<input id="nameLast" v-model="nameLast" type="text" minlength="2" required />
					</div>
				</div>
			</div>
			<div class="label-field">
				<label for="email">
					<i class="fad fa-at"></i> Email
				</label>
				<input id="email" v-model.trim="email" type="email" minlength="9" autocomplete="username" required />
			</div>
			<div class="label-field">
				<label for="password">
					<i class="fad fa-key"></i> Password
				</label>
				<input v-if="!isPrivate" id="password" v-model="password" type="password" minlength="6" autocomplete="current-password" required />
				<div v-else>
					<p>User must use the reset/forgot password link on the login page.</p>
				</div>
			</div>
			<div v-if="isPrivate" class="label-field">
				<label for="role">
					<i class="fad fa-user-tag"></i> Role
				</label>
				<select name="role" v-model="role" v-if="role !== 'admin'">
					<option value="0">Unassigned</option>
					<option value="captain">Dance Captain</option>
					<option value="adjudicator">Adjudicator</option>
					<option value="applicant">Applicant</option>
				</select>
				<div v-else>
					<strong>{{role}}</strong><input v-model="role" type="hidden" />
				</div>
			</div>
			<div v-if="isPrivate && role === 'applicant'" class="label-field">
				<label for="applications">
					<i class="fad fa-file-user"></i> Applications <span v-if="applications.length < 1" v-on:click="addApplication"><i class="fad fa-file-plus"></i>
				</span>
				</label>
				<div v-for="application in applications" v-bind:key="application.id">
					ID: {{application}}
				</div>
				<div v-if="applications.length < 1">No Application</div>
			</div>
			<div v-if="isPrivate" class="label-field">
				<label for="group">
					<i class="fad fa-object-group"></i> Group (Tier 1)
				</label>
				<select name="group" v-model="group">
					<option value="0">Unassigned 0</option>
					<option value="a">Review Group A</option>
					<option value="b">Review Group B</option>
					<option value="c">Review Group C</option>
					<option value="d">Review Group D</option>
					<option value="e">Review Group E</option>
					<option value="f">Review Group F</option>
					<option value="9">Review Group 9 (test)</option>
				</select>
			</div>
			<div v-if="isPrivate" class="label-field">
				<label for="group-2">
					<i class="fad fa-object-ungroup"></i> Group (Tier 2)
				</label>
				<select name="group-2" v-model="group2">
					<option value="0">Unassigned 0</option>
					<option value="g">Review Group G - Tier 2</option>
				</select>
			</div>
		</fieldset>
		<fieldset>
			<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
			<div v-else class="label-field">
				<button>
					<span>SUBMIT</span> <i class="fad fa-angle-right fa-fw"></i>
				</button>
			</div>
		</fieldset>
	</form>
</template>
<script>
export default {
	emits: ['save-user'],
	props: {
		isLoading: {
			type: Boolean
		},
		isPrivate: {
			type: Boolean
		},
		title: {
			type: String
		},
		icon: {
			type: String
		},
		user: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			nameFirst: this.user.nameFirst || null,
			nameLast: this.user.nameLast || null,
			email: this.user.email || null,
			password: this.user.password || null,
			role: this.user.role || 0,
			group: this.user.group || 0,
			group2: this.user.group2 || 0,
			docGroup: this.user.docGroup || null,
			docGroup2: this.user.docGroup2 || null,
			uid: this.user.uid || null,
			dateCreated: this.user.dateCreated || null,
			applications: this.user.applications || []
		}
	},
	computed: {
		applicantList(){
			return this.$store.getters.applicantsAlpha
		}
	},
	methods: {
		addApplication(){
			var app = this.$store.getters.applicantByEmail(this.email)
			if(app !== undefined){
				this.applications.push(app.id)
			} else {
				alert('No App Found :(')
			}
		},
		async loadApplicants() {
			await this.$store.dispatch('loadApplicants')
		},
		saveUser(){

			let userData = {
				nameFirst: this.nameFirst,
				nameLast: this.nameLast,
				email: this.email,
				password: this.password,
				role: this.role,
				group: this.group,
				group2: this.group2,
				docGroup: this.docGroup,
				docGroup2: this.docGroup2,
				uid: this.uid,
				dateCreated: this.dateCreated,
				applications: this.applications
			}

			this.$emit('save-user',userData)

		}
	},
	created() {
		if( this.applicantList.length <= 1){
			console.log('loading...')
			this.loadApplicants()
		}
	}
}
</script>
<style scoped>
form {
	max-width: 720px;
}

.button {
	cursor: pointer;
}
</style>
